export const createCheckDate = (dateInput?: Date | string) => {
    const date = dateInput ? new Date(dateInput) : new Date();
    date.setHours(0, 0, 0, 0);

    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1;
    const currentDate = date.getDate();
    const currentDateString = `${currentYear}-${currentMonth.toString().padStart(2, "0")}-${currentDate.toString().padStart(2, "0")}`;

    const nextDate = dateInput ? new Date(dateInput) : new Date();
    nextDate.setDate(date.getDate() + 1);

    const nextDateYear = nextDate.getFullYear();
    const nextDateMonth = nextDate.getMonth() + 1;
    const nextDateDate = nextDate.getDate();
    const nextDateString = `${nextDateYear}-${nextDateMonth.toString().padStart(2, "0")}-${nextDateDate.toString().padStart(2, "0")}`;
    return { date, currentDateString, nextDateString };
};
